import React from "react";
import ServiceContainer from "../containers/Service";

const User = () => {
  return <ServiceContainer />;
};

export default User;
